<template>
  <div class="companyposition2">
    <basic-container>
      <el-tabs v-model="activeName" @tab-click="tabClick">
        <el-tab-pane label="员工管理" name="first"></el-tab-pane>
        <el-tab-pane label="角色管理" name="second"></el-tab-pane>
      </el-tabs>
      <div class="min">
        <el-row type="flex" :gutter="10">
          <el-col
            style="min-width: 190px; max-width: 280px; margin-right: 14px"
          >
            <el-card class="box-card" shadow="never">
              <div class="flex flex-between flex-item-center topName">
                角色
                <el-button type="primary" size="small"  plain @click="addRole"
                  >新增角色</el-button
                >
              </div>
              <!-- <div style="padding-left: 14px">
                <el-button type="primary" size="small" @click="addPos">
                  新 增</el-button
                >
              </div> -->
              <!-- <div class="flex flex-between flex-item-center topName">
                <div class="name">职位名称</div>
                <div class="tools">操作</div>
              </div> -->
              <!-- <div class="position-list">
                <div
                  class="position-item"
                  v-for="(item, index) in listsData"
                  :key="index"
                  :class="{ active: item.id == selectId }"
                  @click="changePosition(item.id, item.childMenuIds, index)"
                >
                  <div class="name">{{ item.positionName }}</div>
                  <div class="tools del" @click="delPosition(item)">删除</div>
                </div>
              </div> -->
              <div class="tree">
                <el-tree
                  ref="tree1"
                  :data="listsTreeData"
                  node-key="id"
                  default-expand-all
                  @node-click="changePosition"
                  :props="{
                    children: 'children',
                    label: 'positionName',
                  }"
                >
                  <template slot-scope="{ node, data }">
                    <div class="tree-label" v-if="data.ifParent">
                      <img src="@/static/company/people-icon.png" alt="" />
                      {{ data.positionName }}
                    </div>
                    <div class="tree-label" v-else>
                      <i class="el-icon-user-solid" color="#35b1ff"></i>
                      {{ data.positionName }}
                    </div>
                  </template>
                </el-tree>
                <el-tree
                  ref="tree1"
                  :data="listsTreeData1"
                  node-key="id"
                  default-expand-all
                  @node-click="changePosition"
                  :props="{
                    children: 'children',
                    label: 'positionName',
                  }"
                >
                  <template slot-scope="{ node, data }">
                    <div class="tree-label" v-if="data.ifParent">
                      <img src="@/static/company/zdy-icon.png" alt="" />
                      {{ data.positionName }}
                    </div>
                    <span class="tree-label" v-else>
                      <i
                        class="el-icon-user-solid"
                        style="color: #fe9a36"
                        color="#35b1ff"
                      ></i>
                      {{ data.positionName }}
                      <span class="del" @click="delPosition(data)">删除</span>
                    </span>
                  </template>
                </el-tree>
              </div>
            </el-card>
          </el-col>
          <el-col class="user__main" :class="{ 'is-add': addVisible }">
            <div class="add" v-if="addVisible">
              <avue-form :option="tableOption" ref="form" v-model="form">
              </avue-form>
            </div>
            <div class="top-info" v-else>
              <div class="left">
                <div class="label">
                  <i class="el-icon-user-solid" color="#35b1ff"></i
                  >{{ curRole.positionName }}
                </div>
                <div class="desc">{{ curRole.positionDesc }}</div>
              </div>
              <div class="right">
                <img
                  src="@/static/company/people-plain-icon.png"
                  alt=""
                />包含{{ curRole.staffCount }}人
              </div>
            </div>
            <div style="padding: 10px 0; font-weight: 500">功能权限</div>
            <div class="cards" :class="{ 'is-add': addVisible }">
              <el-card shadow="never">
                <el-tree
                  ref="tree2"
                  :data="getMenuData(0, 2)"
                  show-checkbox
                  node-key="id"
                  :default-checked-keys="selectIds"
                  :props="{
                    children: 'children',
                    label: 'name',
                  }"
                >
                </el-tree>
              </el-card>
              <el-card shadow="never">
                <el-tree
                  ref="tree3"
                  :data="getMenuData(2, 4)"
                  show-checkbox
                  node-key="id"
                  :default-checked-keys="selectIds"
                  :props="{
                    children: 'children',
                    label: 'name',
                  }"
                >
                </el-tree>
              </el-card>
              <el-card shadow="never">
                <el-tree
                  ref="tree4"
                  :data="getMenuData(4, 6)"
                  show-checkbox
                  node-key="id"
                  :default-checked-keys="selectIds"
                  :props="{
                    children: 'children',
                    label: 'name',
                  }"
                >
                </el-tree>
              </el-card>
              <el-card shadow="never" class="last-card">
                <el-tree
                  ref="tree5"
                  :data="getMenuData(6, menuData.length)"
                  show-checkbox
                  node-key="id"
                  :default-checked-keys="selectIds"
                  :props="{
                    children: 'children',
                    label: 'name',
                  }"
                >
                </el-tree>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="btns">
        <el-button @click="closeAdd" v-if="addVisible">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </div>
    </basic-container>
  </div>
</template>

<script>
import {
  getPage,
  getObj,
  addObj,
  putObj,
  delObj,
  systemmenu,
  getList,
} from "@/api/chain/companyposition";
import { tableOption } from "@/const/crud/chain/companyposition2";
import { mapGetters } from "vuex";

export default {
  name: "companyposition2",
  data() {
    return {
      addVisible: false,
      chooseEle: null,
      listsTreeData: [],
      selectIndex: 0,
      selectId: "",
      selectIds: [],
      form: {},
      noMenuData: [],
      menuData: [],
      listsData: [],
      tableData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        ascs: [], //升序字段
        descs: [], //降序字段
      },
      paramsSearch: {},
      tableLoading: false,
      tableOption: tableOption,
      activeName: "second",
      listsTreeData1: [],
    };
  },
  created() {
    this.getList();
  },
  updated() {
    // this.changeTreeClass();
  },
  computed: {
    curRole() {
      if (this.selectId) {
        return this.listsData.find((v) => v.id == this.selectId);
      } else {
        return {
          positionName:"",
          staffCount:"",
          positionDesc:""
        };
      }
    },
    ...mapGetters(["permissions"]),
    permissionList() {
      return {
        addBtn: this.permissions["chain:companyposition:add"] ? true : false,
        delBtn: this.permissions["chain:companyposition:del"] ? true : false,
        editBtn: this.permissions["chain:companyposition:edit"] ? true : false,
        viewBtn: this.permissions["chain:companyposition:get"] ? true : false,
      };
    },
    getAllCheckedIds() {
      let checkIds2 = this.$refs.tree2.getCheckedKeys(true);
      let checkIds3 = this.$refs.tree3.getCheckedKeys(true);
      let checkIds4 = this.$refs.tree4.getCheckedKeys(true);
      let checkIds5 = this.$refs.tree5.getCheckedKeys(true);
      return [...checkIds2, ...checkIds3, ...checkIds4, ...checkIds5].join(",");
    },
  },
  methods: {
    closeAdd() {
      this.form = {};
      this.addVisible = false;
    },
    addRole() {
      this.form = {};
      this.addVisible = true;
      this.$nextTick(() => {
        this.$refs.tree1.setCurrentKey(null);
      });
      this.selectId = "";
      this.selectIds = [];
      this.$refs.tree2.setCheckedNodes(this.selectIds);
      this.$refs.tree3.setCheckedNodes(this.selectIds);
      this.$refs.tree4.setCheckedNodes(this.selectIds);
      this.$refs.tree5.setCheckedNodes(this.selectIds);
    },
    getMenuData(start, end) {
      return this.menuData.slice(start, end);
    },
    renderContent(h, { node, data }) {
      if (data.children) {
        // 如果是父节点，禁止点击
        return h(
          "span",
          {
            style: { color: "#999", cursor: "not-allowed" },
            on: {
              click: (event) => event.preventDefault(),
            },
          },
          data.positionName
        );
      } else {
        // 子节点正常显示
        return h("span", data.positionName);
      }
    },
    tabClick(e) {
      if (e.name == "first") {
        this.$router.push({ path: "/chain/enterprise/companystaff" });
      }
    },
    // renderContent(h, { node, data }) {
    //   let className = ""; // perms这个是后台数据区分普通tree节点和横向tree节点的标志  各位要根据实际情况做相对应的修改
    //   console.info(node.level);
    //   if (node.level == 1) {
    //     className = "level1";
    //   }
    //   if ( !data.children && !node.parent.childNodes.some(v=>v.data.children)) {
    //     className = "especially";
    //   }
    //   if (node.level != 1 && data.children) {
    //     className = "level2";
    //   }

    //   return (
    //     // 在需要做横向排列的模块做标记

    //     <div class={className}> {node.label} </div>
    //   );
    // }, // 改变tree节点样式

    // changeTreeClass() {
    //   // 找到之前做标记的class

    //   var classDomList = document.getElementsByClassName("especially"); // 改变这几个样式
    //   var classLevelDomList = document.getElementsByClassName("level1"); // 改变这几个样式
    //   var classLevel2DomList = document.getElementsByClassName("level2");

    //   for (var i = 0; i < classDomList.length; i++) {
    //     classDomList[i].parentNode.style.cssText = "float: left";

    //     classDomList[i].parentNode.className =
    //       "el-tree-node__content option-wrapper";

    //     let parentN = classDomList[i].parentNode.parentNode;
    //     parentN.style.marginLeft = "60px";
    //   }
    //   for (var i = 0; i < classLevelDomList.length; i++) {
    //     classLevelDomList[i].parentNode.parentNode.style.borderBottom =
    //       "1px solid #EBEEF5";
    //     classLevelDomList[i].parentNode.parentNode.style.padding = "10px 0";
    //   }
    //   for (var i = 0; i < classLevel2DomList.length; i++) {
    //     if(i!=classLevel2DomList.length-1){
    //       classLevel2DomList[i].parentNode.parentNode.style.padding = "5px 0";
    //     }

    //   }
    // },
    updatePs() {
      // let pri = [];
      // this.menuData.map((item, index) => {
      //   if (item.checked || item.indeterminate) {
      //     pri.push(item.id);
      //     item.children.map((its) => {
      //       if (its.checked) {
      //         pri.push(its.id);
      //       }
      //     });
      //   }
      // });
      // console.info(this.selectId);
      let checkIds = this.$refs.tree.getCheckedKeys(true);
      console.log(checkIds);
      let data = {
        id: this.selectId,
        v2SystemMenuId: checkIds.join(","),
      };
      putObj(data)
        .then((res) => {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.getList();
        })
        .catch((err) => {
          this.$message({
            type: "info",
            message: "修改失败",
          });
        });
    },
    changePosition(data, node, ele) {
      this.addVisible = false;
      // if (!node.children) {
      //这里就是子级了
      if (data.ifParent) {
        // 如果点击的是父级，则移除父级的is-current这个class
        ele.$el.classList.remove("is-current");
        // 第一次点击的时候，this.chooseEle并没有指定，所以判断一次
        if (this.chooseEle) {
          // 上面已经存了，所以移除父级的is-current之后，给之前点击过得子级添加回is-current这个class
          this.chooseEle.classList.add("is-current");
        }
      } else {
        //这里存一下是子级的元素，防止eleui点击父级的之后找不到上一次的子级。
        this.chooseEle = ele.$el;
        // 移除其他子级的is-current这个class
        const eles = document.querySelectorAll(
          ".el-tree-node__children .el-tree-node.is-focusable"
        );
        for (let i = 0; i < eles.length; i++) {
          eles[i].classList.remove("is-current");
        }
        // 给当前点击的这个子级添加is-current这个class
        this.chooseEle.classList.add("is-current");
        this.selectId = data.id;
        this.selectIds = data.v2ChildMenuId ? data.v2ChildMenuId.split(",") : [];
        this.$refs.tree2.setCheckedNodes(this.selectIds);
        this.$refs.tree3.setCheckedNodes(this.selectIds);
        this.$refs.tree4.setCheckedNodes(this.selectIds);
        this.$refs.tree5.setCheckedNodes(this.selectIds);
      }

      console.info(this.selectIds);
      // this.setPerm();
      // }
    },

    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    delPosition(item) {
      let _this = this;
      this.$confirm("是否确认删除此数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return delObj(item.id);
        })
        .then((data) => {
          _this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
          if (this.listsData && this.listsData.length == 1) {
            this.menuData = [];
          }
          this.selectId=""
          this.getList();
        })
        .catch(function (err) {});
    },
    addPos() {
      this.$prompt("请输入职位名称", "新增职位", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{3}/,
        inputErrorMessage: "请输入3个字以上的职位名称",
      })
        .then(({ value }) => {
          let data = {
            positionName: value,
          };
          addObj(data).then((res) => {
            this.$message({
              type: "success",
              message: "新增成功",
            });
            this.getList();
          });
          // this.$message({
          //   type: 'success',
          //   message: '你的邮箱是: ' + value
          // });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },

    getChildren(item) {
      if (item.children) {
        if (item.children.length > 0) {
          item.children.map((itss) => {
            itss.deptName = `${itss.deptName}(${itss.count})`;
            this.getChildren(itss);
          });
        }
      }
    },
    getsystemmenu() {
      systemmenu().then((res) => {
        // res.data.data.map((item, index) => {
        //   let arr = {
        //     name: item.name,
        //     checked: false,
        //     indeterminate: false,
        //     id: item.id,
        //     children: [],
        //   };
        //   if (item.children) {
        //     item.children.forEach((it) => {
        //       arr.children.push({
        //         name: it.name,
        //         checked: false,
        //         id: it.id,
        //       });
        //     });
        //   }
        //   this.menuData.push(arr);
        // });
        this.menuData = res.data.data;
        // this.noMenuData = JSON.stringify(this.menuData);
        // this.setPerm();
      });
    },
    setPerm() {
      if (!this.listsData[this.selectIndex].systemMenuIds) {
        this.menuData = JSON.parse(this.noMenuData);
      } else {
        let systemMenuIds =
          this.listsData[this.selectIndex].systemMenuIds.split(",");
        console.log(systemMenuIds);
        let arrs = [];
        this.menuData.map((item, index) => {
          let arr = [];
          let count = 0;
          if (item.children) {
            item.children.map((it) => {
              let select = systemMenuIds.includes(it.id);
              if (select) {
                count++;
              }
              arr.push({
                name: it.name,
                checked: select,
                id: it.id,
              });
            });
          }
          let indeterminate = false;
          if (count > 0 && count < arr.length) {
            indeterminate = true;
          }
          arrs.push({
            name: item.name,
            checked: count == arr.length,
            indeterminate,
            id: item.id,
            children: arr,
          });
        });
        this.menuData = arrs;
      }
    },
    getList() {
      getList().then((res) => {
        if (res.data.data) {
          this.listsData = res.data.data;
          this.listsTreeData = [
            {
              positionName: "默认角色",
              children: this.listsData.filter((v) => v.positionOpType == 1),
              disabled: true,
              id: "111",
              ifParent: true,
            },
          ];
          this.listsTreeData1 = [
            {
              positionName: "自定义角色",
              children: this.listsData.filter((v) => v.positionOpType == 2),
              disabled: true,
              id: "111",
              ifParent: true,
            },
          ];
          if (!this.selectId && this.listsData && this.listsData.length > 0) {
            this.selectIndex = 0;
            this.selectId = this.listsData[0].id;
            this.$nextTick(() => {
              this.$refs.tree1.setCurrentKey(this.selectId);
            });

            this.selectIds = this.listsData[0].v2ChildMenuId
              ? this.listsData[0].v2ChildMenuId.split(",")
              : [];
            console.info(this.selectIds);
          } else {
            this.$nextTick(() => {
              this.$refs.tree1.setCurrentKey(this.selectId);
              this.selectIds = this.listsData.find((v) => v.id == this.selectId)
                ? this.listsData
                    .find((v) => v.id == this.selectId)
                    .v2ChildMenuId.split(",")
                : [];

              this.$refs.tree2.setCheckedNodes(this.selectIds);
              this.$refs.tree3.setCheckedNodes(this.selectIds);
              this.$refs.tree4.setCheckedNodes(this.selectIds);
              this.$refs.tree5.setCheckedNodes(this.selectIds);
            });
          }
          if (
            this.menuData.length == 0 &&
            this.listsData &&
            this.listsData.length > 0
          ) {
            this.getsystemmenu();
          }
        }
      });
    },
    searchChange(params, done) {
      params = this.filterForm(params);
      this.paramsSearch = params;
      this.page.currentPage = 1;
      this.getPage(this.page, params);
      done();
    },
    sortChange(val) {
      let prop = val.prop
        ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase()
        : "";
      if (val.order == "ascending") {
        this.page.descs = [];
        this.page.ascs = prop;
      } else if (val.order == "descending") {
        this.page.ascs = [];
        this.page.descs = prop;
      } else {
        this.page.ascs = [];
        this.page.descs = [];
      }
      this.getPage(this.page);
    },
    getPage(page, params) {
      this.tableLoading = true;
      getPage(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            descs: this.page.descs,
            ascs: this.page.ascs,
          },
          params,
          this.paramsSearch
        )
      )
        .then((response) => {
          this.tableData = response.data.data.records;
          this.page.total = response.data.data.total;
          this.page.currentPage = page.currentPage;
          this.page.pageSize = page.pageSize;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前删除数据的行数
     *
     **/
    handleDel: function (row, index) {
      let _this = this;
      this.$confirm("是否确认删除此数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return delObj(row.id);
        })
        .then((data) => {
          _this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
          this.getPage(this.page);
        })
        .catch(function (err) {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate: function (row, index, done, loading) {
      let data = {
        id: this.selectId,
        v2SystemMenuId: this.getAllCheckedIds,
      };

      putObj(data)
        .then((response) => {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
          // done();
          this.getList();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "修改失败",
          });
        });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave: function (row, done, loading) {
      if (this.selectId) {
        this.handleUpdate();
      } else {
        // this.form.v2
        this.$refs.form.validate((valid, done, msg) => {
          this.form.v2SystemMenuIds = this.getAllCheckedIds;
          addObj(this.form)
            .then((response) => {
              this.$message({
                showClose: true,
                message: "添加成功",
                type: "success",
              });
              this.addVisible = false;
              done();
              this.getList();
            })
            .catch(() => {
              done();
              this.$message({
                type: "info",
                message: "添加失败",
              });
            });
        });
      }
    },
    /**
     * 刷新回调
     */
    refreshChange(page) {
      this.getPage(this.page);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-tree-node.is-current > .el-tree-node__content {
  background: #e9f2ff;
}
.btns {
  text-align: center;
  border-top: 1px solid #ededf0;
  padding-top: 8px;
}
.add {
  padding-top: 24px;
  background: #F5F7FA;
  border-radius: 8px;
  height: 248px;
  /deep/.el-collapse {
    border: none;
  }
  /deep/.avue-form__group {
    background: #F5F7FA;

    .el-collapse-item__wrap {
      border: none;
    }
    .el-form-item {
      margin-bottom: 32px;
    }
  }
}
.top-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // width: 100%;
  padding: 0 20px;
  height: 96px;
  background: #F5F7FA;
  border-radius: 8px;
  .left {
    .label {
      font-weight: 500;
      font-size: 16px;
      color: #313133;
      margin-bottom: 10px;
      i {
        color: #35b1ff;
        margin-right: 10px;
      }
    }
    .desc {
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
  }
  .right {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    color: #35b1ff;
    img {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }
  }
}
.user-main {
  min-height: calc(100vh - 240px);
  &.is-add {
    min-height: calc(100vh - 416px);
  }
}
.cards {
  display: flex;
  min-height: calc(100vh - 378px);
  &.is-add {
    min-height: calc(100vh - 554px);
  }
  /deep/.el-card {
    border-right: none;
    border-bottom: none;
    border-radius: 0;
  }
  .last-card {
    border-right: 1px solid #ebeef5;
  }
}
.tree-label {
  flex: 1;
  display: flex;
  align-items: center;
  // justify-content: space-between;
  font-weight: 400;
  font-size: 14px;
  color: #313133;
  // height: 32px;
  i {
    color: #35b1ff;
    margin-right: 3px;
  }
  img {
    width: 14px;
    height: 14px;
    margin-right: 3px;
  }
  .del {
    font-weight: 400;
    font-size: 14px;
    color: #35b1ff;
    text-align: right;
    margin-left: auto;
    margin-right: 20px;
    cursor: pointer;
  }
}
/deep/.option-wrapper {
  padding: 0 !important;
}
.custom-tree {
  display: flex;
}
.right {
  padding-top: 20px;
  text-align: right;
}
.tree {
  padding-left: 14px;
}
/deep/.el-tree-node__content {
  height: 32px;
  font-weight: 400;
  font-size: 14px;
  color: #313133;
}
.topName {
  // padding: 4px 10px;
  border-radius: 4px;
  // margin-top: 10px;
  font-weight: 500;
  font-size: 16px;
  color: #313133;
  padding: 0 14px;
  padding-top: 6px;
  align-items: center;
  margin-bottom: 22px;
  /deep/.el-button {
    background: #fff;
    &:hover{
      color: #35b1ff;
      background: #fff;
    }
  }
}
.position-item {
  display: flex;
  align-content: center;
  justify-content: space-between;
  padding: 6px 10px;
  border-radius: 2px;
  margin-top: 4px;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  &:hover {
    background-color: #e8f4ff;
    .name {
      color: #1890ff;
    }
  }
}
.del {
  color: #1890ff;
  cursor: pointer;
}

.box-card {
  min-height: calc(100vh - 240px);
  border-bottom: none;
}
/deep/ .min {
  min-height: calc(100vh - 240px);
  .el-card__body {
    padding-left: 6px;
    padding-right: 6px;
    padding-top: 10px;
  }
}
.lines {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
}
.active {
  background: #e8f4ff;
  .name {
    color: #1890ff;
  }
}
</style>
